// extracted by mini-css-extract-plugin
export default {"table_wrapper":"appliList_table_wrapper__4DB7-","fl_table":"appliList_fl_table__nI3az","fl-table":"appliList_fl-table__bOSwY","table-wrapper":"appliList_table-wrapper__e3Np3"};